window.theme = window.theme || {}
window.theme.autocomplete = window.theme.autocomplete || {}

window.theme.autocomplete.events = {
  UI: {
    QUERY_UPDATED: 'autocomplete:ui:query:updated',
  },

  API: {
    ACTIVE_TERM_UPDATED: 'autocomplete:api:active-term:updated',
    QUERY_FETCHED: 'autocomplete:api:query:fetched',
    FETCH_FAILED: 'autocomplete:api:fetch:failed',
  },

  STATE: {
    RESPONSE_UPDATED: 'autocomplete:state:response:updated',
  },
  TRACKING: {
    PRODUCT_CLICKED: 'autocomplete:tracking:product:clicked',
    PRODUCT_ADDED_TO_CART: 'autocomplete:tracking:product:added-to-cart',
    KEYWORD_CLICKED: 'autocomplete:tracking:keyword:clicked',
    SUBMIT_SEARCH: 'autocomplete:tracking:submit:search',
  },
}

window.theme.autocomplete.config = {
  productSize: 6,
  categorySize: 5,
  keywordSize: 6,
  popularSearchSize: 5,
  debounceMs: 250,
}
